import {authAxios} from "./auth";

export const reportBug = async (payload: {
  reporter: string,
  description: string,
  recaptchaToken: string | undefined
}) => {
  return authAxios.post<{ success: boolean }>(`sdk/report-bug`, payload)
}
